<template>
    <span :class="statusClass" :title="title" class="badge rounded-pill text-dark" data-bs-toggle="tooltip">
        <SvgIcon :path="iconPath" class="w-3 h-3" type="mdi"/>
    </span>
</template>

<script>
export default {
    name: "BookingStatus"
}
</script>
<script setup>
import SvgIcon from "@jamescoyle/vue-icon";
import {
    mdiCancel,
    mdiCarClock,
    mdiAlertCircleOutline,
    mdiCheck,
    mdiFileClockOutline,
    mdiAccountClockOutline,
    mdiSwapHorizontal,
} from '@mdi/js';
import {Tooltip} from 'bootstrap'
import {computed, onMounted} from "vue";

const props = defineProps({
    status: {
        type: String,
        required: true
    },
    hideToolTip: {
        type: Boolean,
        default: false
    },
})

const iconPath = computed(() => {
    switch (props.status) {
        case 'waiting_verification':
            return mdiFileClockOutline
        case 'verified':
            return mdiCheck
        case 'unmet':
            return mdiAlertCircleOutline
        case 'cancelled':
            return mdiCancel
        case 'standby':
            return mdiAccountClockOutline
        case 'transferred':
            return mdiSwapHorizontal
        case 'posted':
            return mdiSwapHorizontal
        default:
            return mdiCarClock
    }
})

const title = computed(() => {
    switch (props.status) {
        case 'waiting_verification':
            return 'Waiting Verification'
        case 'verified':
            return 'Verified'
        case 'unmet':
            return 'Unmet'
        case 'cancelled':
            return 'Cancelled'
        case 'standby':
            return 'Pending'
        case 'transferred':
            return 'Transferred'
        case 'posted':
            return 'Posted'
        default:
            return 'Future Vehicle Run'
    }
})

const statusClass = computed(() => {
    switch (props.status) {
        case 'waiting_verification':
            return 'bg-warning-lighten'
        case 'verified':
            return 'bg-success-lighten'
        case 'unmet':
            return 'bg-danger-lighten'
        case 'cancelled':
            return 'bg-secondary-lighten'
        case 'standby':
            return 'bg-secondary-lighten'
        case 'transferred':
            return 'bg-secondary-lighten'
        case 'posted':
            return 'bg-secondary-lighten'
        default:
            return 'bg-info-lighten'
    }
})

onMounted(() => {
    if (!props.hideToolTip) {
        new Tooltip(document.body, {
            selector: '[data-bs-toggle="tooltip"]'
        })
    }
})
</script>


<style scoped>

</style>
